import { useMemo, useState } from "react";
import { Button, DialogActions, DialogTitle } from "@mui/material";
import { useDialog } from "../libs/dialog/DialogProvider";
import usePortfolio from "../hooks/PortfolioProvider";
import Holding from "../models/Holding";
import EvalText from "../components/EvalText";
import AccountSelect from "../components/AccountSelect";
import FormGroup from "../libs/form/FormGroup";
import FormControl from "../libs/form/FormControl";
import Validators from "../libs/form/Validators";
import GTextField from "../libs/textfield/GTextField";
import { TransactionType } from "../shared/Consts";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";
import PortUtils from "../portlibs/PortUtils";
import CheckButton from "../libs/button/CheckButton";
import PortAccount from "../models/PortAccount";

const getQty = (amount:string,price:string,id:string) => {
    const a = parseFloat(amount), p = parseFloat(price)
    if (!price) return "0.000"
    else if (PortUtils.isMutualFund(id)) return (a/p).toFixed(3)
    else return (~~(a/p)).toFixed(3)
}
export default function Reinvest(props:{holding:Holding,reinvest?:boolean}) {
    const {holding} = props;
    const [currentAccount,setCurrentAccount] = useState<number>(holding.transactions[0].accountId)
    const [amount,setAmount] = useState<string>( holding.upcomingDividend.toFixed(3) )
    const [price,setPrice] = useState<string>(holding.price.price.toFixed(3))
    const [qty,setQty] = useState<string>(getQty(amount,price,holding.id))
    const [updateCash,setUpdateCash] = useState<boolean>(!PortUtils.isMutualFund(holding.id) && !holding.isCashEq)
    const {closeDialog} = useDialog()
    const form = useMemo(() => new FormGroup("reinviest", [
        new FormControl("Amount",[Validators.PositiveNumber]),
        new FormControl("Price", [Validators.PositiveNumber]),
        new FormControl("Quantity", [Validators.GreaterOrEqualZero]),
    ]), [])
    
    const {portfolio} = usePortfolio()
    const {setSnackbar} = useSnackbar()
    const account = PortAccount.i
    
    const submit = async () => {
        if (!form.dirty) form.markAllAsDirty()
        if (!form.valid) return

        try {
            const now = new Date()
            const div = holding.transactions[0].clone()
            div.type = TransactionType.dividend
            div.price = 1
            div.quantity = parseFloat(amount)
            div.date = now
            div.note = "Dividend"
            div._id = ""
            const rev = div.clone()
            rev.type = TransactionType.reinvest
            rev.price = parseFloat(price)
            rev.quantity = parseFloat(qty)
            rev.note = "Reinvest"

            await account.update(portfolio, div, updateCash, 0)
            await account.update(portfolio, rev, updateCash, 0)
        }catch(e){
            setSnackbar(e)
        }
        closeDialog()
    }
    const onPrice = (p:string) => {
        console.log('set price', p)
        setPrice(p)
    }
    return <>
        <DialogTitle>{"Reinvest " + holding.id}</DialogTitle>
        <div className="content">
            <AccountSelect {...props} showAll={false} onSelect={setCurrentAccount} current={currentAccount} key="account"/>
            <GTextField controlName="Amount" form={form} label="Amount" variant="standard" value={amount} onChange={(e) => setAmount(e.target.value)}/>
            <EvalText controlName="Price" form={form} label="Price" variant="standard" value={price} onChange={(e) => setPrice(e.target.value)} onEval={onPrice}/>
            <EvalText controlName="Quantity" form={form} label="Quantity" variant="standard" value={qty} onChange={(e) => setQty(e.target.value)} onEval={p => setQty(p)}/>
            <CheckButton key="updateCash" checked={updateCash} onChange={()=>setUpdateCash(!updateCash)} label="Update Cash"/>
        </div>
        <DialogActions>
            <Button onClick={submit}>Submit</Button>
        </DialogActions>
    </>
}